// src/components/DigitalDisplay.js
import React from 'react';
import HamburgerMenu from './HamburgerMenu';
import '../SharedStyles.css'; // Universal styles

const DigitalDisplay = ({ children }) => {
  return (
    <div className="digital-display" style={{ minHeight: '450px' }}>
      {/* Background Layer */}
      <div
        className="digital-background"
        style={{
          backgroundImage: 'url(/assets/images/1_solana-memecoin_digital_star-field_bg_1150px_x_722px.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>
      {/* Hamburger Menu */}
      <HamburgerMenu />
      {/* Active Page Content */}
      <div className="display-content">{children}</div>
    </div>
  );
};

export default DigitalDisplay;
